import React from "react";
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from "react-icons/fa";

const Footer = () => {
  return (
    <footer>
      <div className="footer container">
        <div className="copyright">
          <p>
            Copyright &copy; 2022 - {new Date().getFullYear()} Bee
            <span className="bee">Tech</span>, All Right Reserved{" "}
          </p>
        </div>

        <div className="social">
          <a href="https://www.facebook.com" className="social-link">
            <FaFacebook />
          </a>
          <a
            href="https://twitter.com/FreedomWhyte?t=EXQdpVTsJCsl4VUgAXAzHg&s=09"
            className="social-link"
          >
            <FaTwitter />
          </a>
          <a href="https://www.instagram.com" className="social-link">
            <FaInstagram />
          </a>
          <a
            href="https://www.linkedin.com/in/freedom-patrick-nanewortor-a22235212"
            className="social-link"
          >
            <FaLinkedin />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
